import React from 'react'
import PropTypes from 'prop-types'
import './NotificationBar.css'

class NotificationBar extends React.PureComponent {

  constructor(props){
    super(props)
    this.state = {
      visible: !!props.message
    }
  }

  render() {
    const {message} = this.props
    if (this.state.visible){
      return <div className={this._wrapperClassName()}>
        <div className='notification-bar__content'>
          {this._icon()} <div className='notification-bar__message'> {message}</div>
          <a onClick={this._onClickClose} className='notification-bar__close' href='javascript:void(0)'>x</a>
          <div className='clearfix'/>
        </div>
      </div>
    } else {
      return <div/>
    }
  }

  componentDidMount () {
    if (this.state.visible && this.props.timeBeforeFadeout){
      setTimeout(() => {
        if (this.state.visible){ //if is not closed by user before
          this.setState({visible: false})
        }
        this.props.afterFadeout()
      },this.props.timeBeforeFadeout)
    }
  }

  _onClickClose = () => {
    this.setState({visible: false})
  }


  _wrapperClassName = () => {
    const {type} = this.props
    if (type === 'success'){
      return 'notification-bar__wrapper success'
    } else if (type === 'error') {
      return 'notification-bar__wrapper error'
    } else {
      throw new Error('not implemented error')
    }
  }

  _icon = () => {
    const {type} = this.props
    if (type === 'success'){
      return <span className='fa fa-check-circle' />
    } else if (type === 'error'){
      return <span className='fa fa-times'/>
    } else {
      throw new Error('not implemented error')
    }
  }

}

NotificationBar.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  timeBeforeFadeout: PropTypes.number,
  afterFadeout: PropTypes.func,
}

NotificationBar.defaultProps = {
  timeBeforeFadeout: 3000,
  afterFadeout: () => {}
}

export default NotificationBar


// WEBPACK FOOTER //
// app/javascript/components/NotificationBar/NotificationBar.js